module.exports = __webpack_public_path__ + "img/UTFHNH-2.4a864f46.jpg";